import React, { useState } from "react";
import ContainerEventsQuery from "../Components/ContainerEventsQuery";
import ImgProfileCompétition from "../medias/vecteezy_roadbike-flat-icon_5742035 copier.jpg";
import Select from "react-select";
import Regions from "../Data/ListRegions";
import triDiscover from "../medias/pexels-pixabay-235922.jpg";
import LandscapeOutlinedIcon from "@material-ui/icons/LandscapeOutlined";

export const Performance = () => {
  const [region, setSelectedRegion] = useState({
    value: "Ile-de-France",
    label: "Ile-de-France",
  });
  const handleRegion = (region) => {
    setSelectedRegion(region);
  };

  return (
    <section>
      {/* header */}
      <div className="container mt-5">
        <div className="pt-3 visible-sm"></div>
        <h1 className="text-warning">
          Triathlon&nbsp;: trouver de beaux défis&nbsp;!
        </h1>
        <br />
        <div className="row mb-md-5">
          <div className="col-md-2">
            <img
              src={ImgProfileCompétition}
              alt="Profil débutant"
              className="d-block mx-auto w-100 mb-3"
            />
            <h2 style={{ fontSize: "1rem", fontWeight: "bold" }}>
              Plus haut, plus vite, plus fort
            </h2>
          </div>
          <div className="col-md-6 mb-3 pr-5">
            À la montagne, sur du plat, face au vent ou dans les éléments
            déchaînés de l'Atlantique... Le terrain des courses en triathlon est
            très varié et répond souvent, en France en tout cas, aux envies de
            chaque compétiteur. Construire son plan d'entraînement revient donc
            à poser les épreuves qui permettent de monter le curseur jusqu'au
            format Ironman, pour se défier sur le long, notamment...
          </div>
          {/* header right part */}
          <div className="col-md-4 px-1 sticky-top"></div>
        </div>
      </div>
      {/* page left part*/}
      <div className="row my-2">
        <div className="col-md-8">
          <div className="row mb-4">
            <div className="col-md-4">
              <h5 className="text-warning">Des objectifs stimulants</h5>
              <p>
                Avec un entraînement quotidien et des enchaînements vie
                professionnelle, personnelle et sportive, les compétitions
                forment une sorte d'apogée, sorte d'aboutissement et source de
                satisfaction pour les triathlètes. Si chaque épreuve est un défi
                en soi, certaines marquent cependant d'une pierre blanche la
                saison sportive. Celles en particulier dont le succès sera déjà
                de pouvoir se présenter au départ tant la préparation aura été
                exigeante...
              </p>
            </div>
            <div className="col-md-8">
              <h3 className="font-weight-bold">
                Un triathlon L{" "}
                <span className="text-primary">
                  (moyenne distance ou half-Ironman)
                </span>{" "}
                comme objectif
              </h3>
              <div>
                <h6>Choisir votre région</h6>

                <Select
                  defaultValue="Ile-de-France"
                  onChange={handleRegion}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  options={Regions}
                  value={region}
                  placeholder="Votre région"
                  className="col-md-6 pl-0"
                />
              </div>
              <ContainerEventsQuery
                region={region.value}
                remove={false}
                format={["L"]}
                relay={""}
                Elevation_bike={0}
                Elevation_run={0}
                bibs={25000}
                Swimenv={[
                  "Piscine",
                  "Lac",
                  "Mer",
                  "Rivière",
                  "Plan d'eau",
                  "0",
                ]}
                crosstri={["1", "0"]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <h5 className="text-warning">
                Montagne : vous préférez les triathlons Xtreme&nbsp;?
              </h5>
              <p>
                Étonamment aucune épreuve française de triathlon extrême, qui
                rime généralement avec montagne, ne font partie du label Xtri
                World qui rassemble les Ironman avec du dénivelé et souvent des
                conditions climatiques rigoureuses, à commencer par le norvégien
                Norseman. En revanche, des épreuves mythiques comme l'Embrunman
                ou l'Altriman offrent de réels défis extrêmes. Et se sont
                démocratisées avec des courses plus courtes.
              </p>
            </div>
            <div className="col-md-8">
              <h3 className="font-weight-bold">
                <LandscapeOutlinedIcon className="mr-2" />
                Des épreuves avec un minimum de dénivelé (500 m D+){" "}
                <span className="text-primary">
                  à la montagne ou dans les vallons
                </span>
              </h3>
              <img
                src={triDiscover}
                alt="triathlon - Goran Bogicevic"
                className="img-fluid mb-3"
              />
              <ContainerEventsQuery
                region={region.value}
                remove={false}
                format={["M", "L", "XL", "XXL"]}
                relay={""}
                Elevation_bike={500}
                Elevation_run={100}
                bibs={500}
                Swimenv={[
                  "Piscine",
                  "Lac",
                  "Mer",
                  "Rivière",
                  "Plan d'eau",
                  "0",
                ]}
                crosstri={["1", "0"]}
              />
            </div>
          </div>
        </div>
        {/* page right part*/}
        <div className="col-md-4">
          <div className="container">
            <div className="row">
              <p className="font-weight-bold mb-1">
                Distance Ironman (XXL) : les épreuves françaises
              </p>
              <div className="minsize">
                <ContainerEventsQuery
                  region="Toute la France"
                  remove={false}
                  format={["XXL"]}
                  relay={""}
                  Elevation_bike={0}
                  bibs={25000}
                  Swimenv={[
                    "Piscine",
                    "Lac",
                    "Mer",
                    "Rivière",
                    "Plan d'eau",
                    "0",
                  ]}
                  crosstri={["1", "0"]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
